import { createRoutine } from 'redux-saga-routines';

export const discountCardSearchRoutine = createRoutine('DISCOUNT_CARD/SUBMIT_SEARCH');
export const discountCardSearchFilterRoutine = createRoutine('DISCOUNT_CARD/FILTER_SEARCH');
export const discountCardSetLocationRoutine = createRoutine('DISCOUNT_CARD/SET_LOCATION');
export const discountCardSendSmsEmailRoutine = createRoutine('DISCOUNT_CARD/SEND_EMAIL_CARD');
export const getAutocompleteValues = createRoutine('SCRIPT_SAVE/GET_AUTOCOMPLETE_DATA');
export const generateDiscountCardRoutine = createRoutine('SCRIPT_SAVE/GET_DISCOUNT_CARD');
